var render = function render(){var _vm=this,_c=_vm._self._c;return _c('shop-list',{attrs:{"extra":_vm.extra,"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }